import { Text, TextProps } from "ink";
import React, { FC } from "react";

const makeLine = (length = 28, char = "-") => new Array(length + 1).join(char);

const LINE = makeLine();

interface DividerProps extends TextProps {
	title?: string;
}

const Divider: FC<DividerProps> = ({ title, ...props }) => {
	if (!title) {
		return <Text {...props}>{LINE}</Text>;
	}

	const length = LINE.length - title.length - 2;

	return (
		<Text {...props}>
			-- {title} {length <= 0 ? "--" : LINE.slice(0, Math.max(0, length - 1))}
		</Text>
	);
};

export default Divider;
